var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _rect6, _rect7, _rect8, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "#F3DC1E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70.2266,
    y: 86.2915,
    width: 33.4148,
    height: 2.20509,
    rx: 1.10254,
    transform: "rotate(-30.3102 70.2266 86.2915)",
    fill: "black",
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 98.3809,
    y: 69.4641,
    width: 31.8337,
    height: 2.20509,
    rx: 1.10254,
    transform: "rotate(30.2769 98.3809 69.4641)",
    fill: "black",
    stroke: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 123.045,
    y: 85.1357,
    width: 21.2246,
    height: 2.20509,
    rx: 1.10254,
    transform: "rotate(-29.5795 123.045 85.1357)",
    fill: "black",
    stroke: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 125.373,
    y: 84.7383,
    width: 21.2633,
    height: 2.20509,
    rx: 1.10254,
    transform: "rotate(90 125.373 84.7383)",
    fill: "black",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2228 71.6389C46.3886 70.3885 49.057 70.3885 51.2228 71.6389L70.958 83.033C73.1238 84.2835 74.458 86.5944 74.458 89.0952V111.884C74.458 114.384 73.1238 116.695 70.958 117.946L51.2228 129.34C49.057 130.59 46.3886 130.59 44.2228 129.34L24.4875 117.946C22.3217 116.695 20.9875 114.384 20.9875 111.884V89.0952C20.9875 86.5944 22.3217 84.2835 24.4875 83.033L44.2228 71.6389Z",
    fill: "black",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3011 74.4739C46.4669 73.2234 49.1353 73.2234 51.3011 74.4739L68.5129 84.4111C70.6787 85.6615 72.0129 87.9724 72.0129 90.4732V110.348C72.0129 112.849 70.6787 115.159 68.5129 116.41L51.3011 126.347C49.1353 127.598 46.4669 127.598 44.3011 126.347L27.0893 116.41C24.9235 115.159 23.5893 112.849 23.5893 110.348V90.4732C23.5893 87.9724 24.9235 85.6615 27.0893 84.4111L44.3011 74.4739Z",
    fill: "#F3DC1E",
    stroke: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 48.1934,
    y: 76.3906,
    width: 23.0746,
    height: 2.20509,
    rx: 1.10254,
    transform: "rotate(29.9241 48.1934 76.3906)",
    fill: "black",
    stroke: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 47.25,
    y: 122.741,
    width: 23.0746,
    height: 2.20509,
    rx: 1.10254,
    transform: "rotate(-30.9199 47.25 122.741)",
    fill: "black",
    stroke: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 28.6641,
    y: 88.9912,
    width: 23.0746,
    height: 2.20509,
    rx: 1.10254,
    transform: "rotate(90 28.6641 88.9912)",
    fill: "black",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151.261 64.554H154.166V72.8464C154.166 73.6156 153.986 74.3018 153.626 74.905C153.272 75.5082 152.774 75.9758 152.132 76.3079C151.496 76.6399 150.785 76.8059 149.999 76.8059C148.682 76.8059 147.658 76.4739 146.928 75.8098C146.197 75.1458 145.832 74.205 145.832 72.9875H148.754C148.754 73.5409 148.848 73.9421 149.036 74.1912C149.23 74.4402 149.551 74.5647 149.999 74.5647C150.403 74.5647 150.713 74.4153 150.929 74.1165C151.15 73.8121 151.261 73.3888 151.261 72.8464V64.554ZM162.243 73.4275C162.243 73.0014 162.09 72.6694 161.786 72.4314C161.487 72.1934 160.959 71.9472 160.201 71.6926C159.443 71.4381 158.823 71.1918 158.341 70.9539C156.775 70.1847 155.992 69.1277 155.992 67.783C155.992 67.1134 156.186 66.524 156.573 66.0149C156.966 65.5002 157.52 65.1018 158.233 64.8196C158.947 64.5318 159.75 64.3879 160.641 64.3879C161.509 64.3879 162.287 64.5429 162.973 64.8528C163.665 65.1627 164.202 65.6054 164.583 66.1809C164.965 66.7509 165.156 67.4039 165.156 68.1399H162.251C162.251 67.6474 162.099 67.2655 161.794 66.9944C161.496 66.7232 161.089 66.5876 160.574 66.5876C160.054 66.5876 159.642 66.7039 159.337 66.9363C159.039 67.1632 158.889 67.4537 158.889 67.8079C158.889 68.1178 159.055 68.4 159.387 68.6545C159.719 68.9036 160.303 69.1637 161.139 69.4348C161.974 69.7004 162.66 69.9882 163.197 70.2981C164.503 71.0507 165.156 72.0883 165.156 73.4109C165.156 74.4679 164.758 75.2979 163.961 75.9011C163.164 76.5043 162.071 76.8059 160.682 76.8059C159.703 76.8059 158.814 76.6316 158.018 76.283C157.226 75.9288 156.629 75.4473 156.225 74.8386C155.826 74.2244 155.627 73.5188 155.627 72.7219H158.549C158.549 73.3694 158.715 73.8481 159.047 74.158C159.384 74.4623 159.93 74.6145 160.682 74.6145C161.164 74.6145 161.543 74.5121 161.819 74.3074C162.102 74.0971 162.243 73.8038 162.243 73.4275Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.598 81.46H168.149V80.0635L171.12 76.9404C171.852 76.1068 172.218 75.4445 172.218 74.9536C172.218 74.5558 172.131 74.2533 171.958 74.0459C171.784 73.8385 171.532 73.7349 171.202 73.7349C170.876 73.7349 170.612 73.8745 170.409 74.1538C170.206 74.4289 170.104 74.7738 170.104 75.1885H167.958C167.958 74.6214 168.1 74.0988 168.384 73.6206C168.667 73.1382 169.061 72.7616 169.564 72.4907C170.068 72.2199 170.631 72.0845 171.253 72.0845C172.252 72.0845 173.02 72.3151 173.557 72.7764C174.099 73.2376 174.37 73.8999 174.37 74.7632C174.37 75.1271 174.302 75.4826 174.167 75.8296C174.031 76.1724 173.819 76.5342 173.532 76.915C173.248 77.2917 172.789 77.7974 172.154 78.4321L170.961 79.8096H174.598V81.46Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.654fa0d94bbd11bcb8b6f3b6bd9204c1.svg";
export { ForwardRef as ReactComponent };